var map = {
	"./lesson_6_1.pdf": 1014,
	"./lesson_6_2.pdf": 1015,
	"./lesson_6_3.pdf": 1016,
	"./lesson_6_4.pdf": 1017,
	"./lesson_6_5.pdf": 1018
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1013;